import React, { useEffect, useState } from "react";
import { ReactComponent as Close } from 'src/assets/close.svg';

interface AlertProps {
    title: string;
    onClose: () => void;
    onConfirm?: (filters: { array: string[]; genre: string[]; textType: string[]; }) => void;
    initialFilters?: { array: string[]; genre: string[]; textType: string[] };
}

const AuthorFilterModal: React.FC<AlertProps> = ({ title, onClose, onConfirm, initialFilters }) => {

    const filter_list: string[] = ['등록순', '인기순'];
    const genre_list: string[] = ['소설', '시', '에세이', '인문', '자기계발서', '엽서/일러스트레이션 북']

    const text_type: string[] = ['재미와 감동을 주는', '전문 식견이 담긴', '소재가 신선한', '객관적 근거를 제시하는', '경험을 바탕으로 한', '극적 긴장감을 주는', '감수성이 돋보이는', '나만의 생각이 담긴', '표현력이 자유로운'
        , '상상력이 돋보이는', '주장이 명확한', '논리적인 구조를 갖춘']

    const [selectFilterArray, setSelectFilterArray] = useState<string[]>([]);
    const [selectGenre, setSelectGenre] = useState<string[]>([]);
    const [selectTextType, setSelectTextType] = useState<string[]>([]);

    const filterSingleClick = (item: string) => {
        setSelectFilterArray((prev) =>
            prev.includes(item) ? [] : [item]
        );
    };

    const filterGenreClick = (item: string) => {
        setSelectGenre((prev) =>
            prev.includes(item) ? [] : [item]
        );
    };

    //filter 값 확인 및 유지
    useEffect(() => {
        if (initialFilters) {
            setSelectFilterArray(initialFilters.array || []);
            setSelectGenre(initialFilters.genre || []);
            setSelectTextType(initialFilters.textType || []);
        }
    }, [initialFilters]);

    const handleFilterClick = (item: string, filterType: "genre" | "textType") => {
        if (filterType === "textType") {
            setSelectTextType((prev) =>
                prev.includes(item) ? prev.filter((filter) => filter !== item) : [...prev, item]
            );
        }
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm({
                array: selectFilterArray,
                genre: selectGenre,
                textType: selectTextType,
            });
        }
    };

    return (
        <>
            {/* 오버레이 */}
            <div className="overlay" />

            {/* 모달 */}
            <div className="penpal-alert flex flex-col w-full md:w-[360px] md:h-[620px] max-w-md p-7 rounded-[28px] shadow-2xl border border-[#edfcf5] bg-white">
                {/* Header */}
                <div className="flex justify-between items-center pb-3 mb-4 border-b border-[#f2f8f5]">
                    <h2 className="text-2xl font-bold text-main tracking-tight">{title}</h2>
                    <button className="close-button p-1 hover:bg-[#edfcf5] rounded-full transition-colors" onClick={onClose}>
                        <Close className="w-5 h-5 text-[#888]" />
                    </button>
                </div>

                {/* filter contents */}
                <div className="flex-1 overflow-y-auto mb-4 pr-1">
                    <div className="flex flex-col items-start gap-[26px] px-3">
                        {/* 정렬 필터 */}
                        <div className="flex flex-col gap-[12px]">
                            <span className="text-black font-namsan text-base">정렬</span>
                            <div className="flex flex-wrap gap-2">
                                {filter_list.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() => filterSingleClick(item)}
                                        className={`px-4 py-2 flex justify-center items-center border rounded-[20px] transform transition-transform duration-300 hover:scale-105 text-sm whitespace-nowrap w-auto cursor-pointer
              ${selectFilterArray.includes(item) 
                ? "bg-[#19cf7a] border-[#19cf7a] text-white font-semibold shadow-[0px_4px_12px_rgba(25,207,122,0.15)]" 
                : "border-[#e2e8f0] text-[#4a5568] bg-[#f7fafc] hover:bg-[#eefcf5] hover:border-[#19cf7a] hover:text-[#19cf7a]"}`}
                                    >
                                        {item}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* 장르 필터 */}
                        <div className="flex flex-col gap-[12px]">
                            <span className="text-black font-namsan text-base">장르</span>
                            <div className="flex flex-wrap gap-2">
                                {genre_list.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() => filterGenreClick(item)}
                                        className={`px-4 py-2 flex justify-center items-center border transform transition-transform duration-300 hover:scale-105 rounded-[20px] text-sm whitespace-nowrap w-auto cursor-pointer
              ${selectGenre.includes(item) 
                ? "bg-[#19cf7a] border-[#19cf7a] text-white font-semibold shadow-[0px_4px_12px_rgba(25,207,122,0.15)]" 
                : "border-[#e2e8f0] text-[#4a5568] bg-[#f7fafc] hover:bg-[#eefcf5] hover:border-[#19cf7a] hover:text-[#19cf7a]"}`}
                                    >
                                        {item}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* 글 유형 필터 */}
                        <div className="flex flex-col gap-[12px]">
                            <span className="text-black font-namsan text-base">글 유형</span>
                            <div className="flex flex-wrap gap-2 md:grid md:grid-cols-2">
                                {text_type.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleFilterClick(item, "textType")}
                                        className={`px-3 py-2 flex justify-center items-center border transform transition-transform duration-300 hover:scale-105 rounded-[20px] text-sm md:text-xs whitespace-nowrap w-auto cursor-pointer
        ${selectTextType.includes(item) 
            ? "bg-[#19cf7a] border-[#19cf7a] text-white font-semibold shadow-[0px_4px_12px_rgba(25,207,122,0.15)]" 
            : "border-[#e2e8f0] text-[#4a5568] bg-[#f7fafc] hover:bg-[#eefcf5] hover:border-[#19cf7a] hover:text-[#19cf7a]"}`}
                                    >
                                        {item}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-center mt-4 w-full">
                    <button
                        onClick={() => {
                            handleConfirm();
                            onClose();
                        }}
                        className="w-full py-3 bg-[#19cf7a] hover:bg-[#15af67] text-white text-base font-bold rounded-2xl shadow-[0_4px_12px_rgba(25,207,122,0.2)] hover:shadow-[0_6px_16px_rgba(25,207,122,0.3)] hover:scale-[1.01] active:scale-95 transition-all duration-300 cursor-pointer"
                    >
                        적용하기
                    </button>
                </div>
            </div>
        </>
    );
}

export default AuthorFilterModal;
